import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { getColor } from "../util/CC";
import { Button, Drawer } from "antd";
import Html from "../components/utilities/Html";

export default function CookieNotice(props) {

    const template = window.sitesettings.template_info;
    const { content = {} } = props;
    const [open, setOpen] = useState(false);

    const {
        location = "main",
        component = "cookie_notice",
        container = true,
        injected_data = {},
        data = {}
    } = content;

    const { 
        background_colour = 0,
        gap = 10,
        padding_x = 20,
        padding_y = 20,
        heading = "How We Use Cookies",
        heading_preset = 0,
        paragraph = "We only utilize essential cookies which are required for our website to function, allowing users to remain logged in or anonymous (not logged in) users' carts to be retained for a period of time. We do not use optional cookies, nor do we share personal information with our partners or third parties beyond details obtained through checkout that may be used to process payments or facilitate shipping. By continuing to use this site, you agree to our use of these essential cookies. For more information, see our Terms & Conditions.",
        paragraph_preset = 0,
        max_width = true,
        placement = "center",
        align = "center",
        container_width= 1248,
        button_label = "I Understand",
        button_type = 0,
        button_block= false,
        link_id = 0,
        show_once = false,
    } = data;

    const drawerRender = () => {
        return (
            <div>
                {(heading &&
                    <h4 style={{ "display": "block" }} className={"bm-txt-" + heading_preset} >
                        {heading}
                    </h4>
                )}
                <div className="shim" style={{ "height": gap + "px" }} />
                {(paragraph &&
                    <div className={"bm-txt-" + paragraph_preset} >
                        <Html anchor={"bm-lnkin-" + link_id} html={paragraph} />
                    </div>    
                )}
                {(button_label &&
                <div style={{ display: 'flex', justifyContent: align }}>
                    <Button className={"bm-btn-" + button_type} block={button_block} onClick={() => setOpen(false)} >{button_label}</Button>
                </div>
                )}
            </div>
        )
    }

    const positioning = (placement, width ) => {
        if (placement === "left") {
            return {
                left: 0,
                right: "auto"
            }
        } else if (placement === "right") {
            return {
                left: "auto",
                right: 0
            }
        } else {
            return {
                left: '50%',
                right: 'auto',
                marginLeft: -(width / 2),
            }
        }
    }

    useEffect(() => {
        if (show_once) {
            const cookieName = props.id ? props.id : "cookieLoaded";
            const seenPopup = Cookies.get(cookieName);
            if (!seenPopup) {
                setOpen(true);
                Cookies.set(cookieName, "true", { expires: 1 });
            }
        } else {
            setOpen(true);
        }
    }, []);

    const drawRender = () => {
        return (
            <Drawer
                placement="bottom"
                closable={false}
                mask={true}
                height="auto"
                zIndex={1000}
                onClose={() => setOpen(false)}
                open={open}
                motion={{
                    motionName: "ant-slide-up",
                    motionAppear: true,
                    motionEnter: true,
                    motionLeave: true,
                }}
                contentWrapperStyle={{
                    width: max_width ? "100%" : container_width + "px",
                    ...(!max_width ? positioning(placement, container_width) : {}),
                }}
                drawerStyle={{ backgroundColor: getColor(background_colour, template, "#fff") }}
                styles={{
                    wrapper: { boxShadow: 'none', borderTop: '1px solid #f0f0f0' },
                }}
                bodyStyle={{ padding: `${padding_y}px ${padding_x}px` }}
                >
                    {drawerRender()}
            </Drawer>
        )
    }

    return drawRender();
}